import React, { useEffect, useRef, useState } from "react";
import Logo from "images/logo_menu.svg";
import { graphql, useStaticQuery } from "gatsby";

type AdsProps = {
    idx: number;
};

export const Ads = ({ idx }: AdsProps) => {
    // useEffect(() => {
    //     if (typeof window !== "undefined") {
    //         try {
    //             window.adsbygoogle = window.adsbygoogle || [];
    //             window.adsbygoogle.push({});
    //         } catch (e) {}
    //     }
    // }, []);
    const data: {
        siteFeaturesJson: {
            firstText: string;
            firstTitle: string;
            secondText: string;
            secondTitle: string;
            thirdText: string;
            thirdTitle: string;
        };
    } = useStaticQuery(graphql`
        {
            siteFeaturesJson: articlesJson(key: { eq: "site-features" }) {
                firstText
                firstTitle
                secondText
                secondTitle
                thirdText
                thirdTitle
            }
        }
    `);
    let text: string;
    const idxLimited = idx % 3;
    switch (idxLimited) {
        case 0:
            text = data.siteFeaturesJson.firstText;
            break;
        case 1:
            text = data.siteFeaturesJson.secondText;
            break;
        case 2:
            text = data.siteFeaturesJson.thirdText;
            break;
    }
    const ref = useRef(null);
    const [adShown, setAdShown] = useState(false);
    useEffect(() => {
        if (adShown) return;
        const intervalId = setInterval(() => {
            if (ref.current && ref.current.children.length > 1) {
                const iframe = ref.current.querySelector("iframe");
                if (iframe) {
                    const frameWidth = parseInt(
                        iframe.getAttribute("width"),
                        10
                    );
                    if (frameWidth > 1) {
                        setAdShown(true);
                    }
                }
            }
        }, 500);
        return () => clearInterval(intervalId);
    }, [adShown]);
    return (
        <div
            key={"ad_" + idx}
            ref={ref}
            className="raptive-placeholder-content relative my-8 flex min-h-[300px] items-center justify-center text-center md:my-12"
        >
            <div
                className={`absolute max-w-[300px] ${
                    adShown ? "invisible" : "md:max-w-[500px]"
                }`}
            >
                <img
                    src={Logo}
                    alt="Sunheron logo"
                    className="m-auto mb-2 h-[24px] w-[24px] transition duration-300"
                />
                <span>{text}</span>
            </div>
        </div>
    );
};
